import React from "react";
import styles from "./styles";
import {
  withStyles,
  CardContent,
  Card,
  CardHeader,
  withTheme,
  IconButton,
} from "@material-ui/core";
import { compose } from "recompose";
import ReturnToTerminalIcon from "../../../../IBPlanning/Common/ReturnToTerminalIcon";
import { ALL_DRIVER_STATUS } from "../../constants";
import { format } from "date-fns";
import EndTripIcon from "../../../../../../layout/icons/EndTripIcon";
import Tooltip from "../../../../../common/StyledToolTip";
import EndTripConfirmation from "../../EndTrip/EndTripConfirmation";

class TerminalCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEndTripModal: false,
    };
  }

  hideEndTripModal = () => {
    this.setState({
      showEndTripModal: false,
    });
  };

  onShowEndTrip = () => {
    this.setState({
      selectedDispatchRoute: {
        driverId: this.props.routeData.driverId,
        routeId: this.props.routeData.routeId,
      },
      showEndTripModal: true,
    });
  };

  renderEndTripIcon = () => {
    const { classes, theme, routeData } = this.props;
    const enableIcon =
      routeData?.routeStatus === ALL_DRIVER_STATUS.ArrivedAtTerminal;
    return (
      <Tooltip title={"End Trip"}>
        <IconButton
          aria-label="End Trip"
          component="div"
          disabled={!enableIcon}
          className={enableIcon ? classes.enableIcon : classes.disableIcon}
          onClick={this.onShowEndTrip}
        >
          <EndTripIcon color={enableIcon ? theme.error : theme.iconColor} />
        </IconButton>
      </Tooltip>
    );
  };
  render() {
    const { classes, userData, routeData } = this.props;
    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{
            title: classes.title,
            subheader: classes.subheader,
            root: classes.headerRoot,
            avatar: classes.avatar
          }}
          action={this.renderEndTripIcon()}
          avatar={<ReturnToTerminalIcon width={42} height={42} />}
          title={`${userData.userProfile.terminal.code}: RETURN TO TERMINAL`}
          subheader={""}
        />
        <CardContent className={classes.noPadding}>
          <div className={classes.statusWrapper}>
            <span className={classes.statusTime}>
              {routeData.routeStatus === ALL_DRIVER_STATUS.ArrivedAtTerminal
                ? "Arrived at terminal"
                : "ETA"}
            </span>
            <span className={classes.statusTime}>
              {format(routeData.arriveAtTerminalTime, "HH:mm")}
            </span>
          </div>
        </CardContent>
        {this.state.showEndTripModal ? (
          <EndTripConfirmation
            onCancel={this.hideEndTripModal}
            userData={userData}
            driverInfo={routeData}
          />
        ) : null}
      </Card>
    );
  }
}

export default compose(withStyles(styles), withTheme())(TerminalCard);
